import { useEffect, useState } from "react";
import { useTheme } from "../../theme";
import { AnimationType } from "./types";

const animationCache: Record<string, any> = {};

// eslint-disable-next-line import/prefer-default-export
export const useSpinner = (spinnerType: AnimationType): string => {
  const [spinner, setSpinner] = useState<any>(null);
  const theme = useTheme();

  useEffect(() => {
    let isMounted = true;

    const key = spinnerType!;
    if (animationCache[key]) {
      if (isMounted) {
        // If animation exists in cache, use it
        setSpinner(animationCache[key]);
      }
    } else {
      // Load the animation and store it in cache
      const loadSpinner = async () => {
        try {
          const type = spinnerType === "expanding" ? theme.spinners.expanding : theme.spinners.shrinking;
          const animationModule = await import(`../../assets/spinners/${type}`);
          animationCache[key] = animationModule.default;
          if (isMounted) {
            setSpinner(animationModule.default);
          }
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error("Error loading Lottie animation:", error);
        }
      };
      loadSpinner();
    }

    return () => {
      isMounted = false;
    };
  }, [spinnerType, theme.spinners.expanding, theme.spinners.shrinking]);

  return spinner;
};
